import React, { useEffect, useRef, useState } from 'react'
import { checkAddPermission, checkDeletePermission, checkEditPermission, fetchBrand, fetchBrandFilter, fetchCategoryData, fetchCategoryDataFilter, fetchGetList, fetchOriginData, fetchOriginDataFilter, filteredCategories, handleExportFile, handleExportFileProduct, handleImportClickFile, handleSelectionChange, handleUpdateAllCheckbox, handleUpdateDataCheckbox, relatedProductsLoadOptions, resetFormData, setupEditFormData, TableFooter } from '../../../Utils/helper'
import { useDispatch, useSelector } from 'react-redux';
import Import from '../../../Utils/import';
import { getApi } from '../../../Services/apiService';
import DeleteModal from '../../../Utils/deleteModal';
import EditProduct from './editProduct';
import { AsyncPaginate } from 'react-select-async-paginate';
import { setIdsStatus } from '../../../Counter/createGroup';
import { useNavigate } from 'react-router-dom';
import MultiSelectDropdown from '../../../Utils/multiSelectDropdown';

function Product() {
  const dropdownRef = useRef()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [methodType, setMethodType] = useState('');
  const { data } = useSelector((state) => state.roleData);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDatas, setFilterData] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [product, setProduct] = useState([])
  const [productToDelete, setProductToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);
  const [showGroupCodesModal, setShowGroupCodesModal] = useState(false);
  const [selectedProductGroups, setSelectedProductGroups] = useState([]);
  const [formData, setFormData] = useState({
    brand: "",
    brand_code: "",
    category: '',
    coo: '',
    category_id: "",
    category_code: "",
    code: "",
    company_product_id: "",
    company_product_id_code: "",
    coo_id: "",
    coo_code: "",
    gross_Weight_unit: "",
    gross_weight_value: "",
    logistics_fee_Calculation_mode: "",
    name_en: "",
    name_tc: "",
    net_weight: "",
    pic_staff_member_import: "",
    pic_staff_member_sales: "",
    pid: "",
    quantity_per_packaging_unit: "",
    remarks: "",
    specification: "",
    specification_code: "",
    status: "",
    type: "",
    variety: "",
    varietyCode: "",
    //      brand: "",
    //   brand_code: "",
    //   category: "",
    //   category_code: "",
    //   code: "",
    //   company_product_id: "",
    //   company_product_id_code: "",
    //   coo_id: "",
    //   coo_code: "",
    //   gross_Weight_unit: "",
    //   gross_weight_value: "",
    //   logistics_fee_Calculation_mode: "",
    //   name_en:"",
    //   name_tc: "",
    //   net_weight: "",
    //   pic_staff_member_import: "",
    //   pic_staff_member_sales: "",
    //   pid: "",
    //   quantity_per_packaging_unit: "",
    //   remarks:"",
    //   specification: "",
    //   specification_code: "",
    //   status: "",
    //   type: "",
    //   variety: "",
    //   varietyCode: ""
  });
  const [formDataCopy, setFormDataCopy] = useState({
    // name_en: '',
    // name_tc: '',
    // code: '',
    // category: '',
    // coo: '',
    // variety: '',
    // net_weight: '',
    // specification: '',
    // is_active: true  // Default to active when creating new buyer
    brand: "",
    brand_code: "",
    category: '',
    coo: '',
    category_id: "",
    category_code: "",
    code: "",
    company_product_id: "",
    company_product_id_code: "",
    coo_id: "",
    coo_code: "",
    gross_Weight_unit: "",
    gross_weight_value: "",
    logistics_fee_Calculation_mode: "",
    name_en: "",
    name_tc: "",
    net_weight: "",
    pic_staff_member_import: "",
    pic_staff_member_sales: "",
    pid: "",
    quantity_per_packaging_unit: "",
    remarks: "",
    specification: "",
    specification_code: "",
    status: "",
    type: "",
    variety: "",
    varietyCode: "",
    //      brand: "",
    //   brand_code: "",
    //   category: "",
    //   category_code: "",
    //   code: "",
    //   company_product_id: "",
    //   company_product_id_code: "",
    //   coo_id: "",
    //   coo_code: "",
    //   gross_Weight_unit: "",
    //   gross_weight_value: "",
    //   logistics_fee_Calculation_mode: "",
    //   name_en:"",
    //   name_tc: "",
    //   net_weight: "",
    //   pic_staff_member_import: "",
    //   pic_staff_member_sales: "",
    //   pid: "",
    //   quantity_per_packaging_unit: "",
    //   remarks:"",
    //   specification: "",
    //   specification_code: "",
    //   status: "",
    //   type: "",
    //   variety: "",
    //   varietyCode: ""
  });
  const [touched, setTouched] = useState({
    brand: false,
    brand_code: false,
    category: false,
    coo: false,
    category_id: false,
    category_code: false,
    code: false,
    company_product_id: false,
    company_product_id_code: false,
    coo_id: false,
    coo_code: false,
    gross_Weight_unit: false,
    gross_weight_value: false,
    logistics_fee_Calculation_mode: false,
    name_en: false,
    name_tc: false,
    net_weight: false,
    pic_staff_member_import: false,
    pic_staff_member_sales: false,
    pid: false,
    quantity_per_packaging_unit: false,
    remarks: false,
    specification: false,
    specification_code: false,
    status: false,
    type: false,
    variety: false,
    varietyCode: false,
    //      brand: false,
    //   brand_code: false,
    //   category: false,
    //   category_code: false,
    //   code: false,
    //   company_product_id: false,
    //   company_product_id_code: false,
    //   coo: false,
    //   coo_code: false,
    //   gross_Weight_unit: false,
    //   gross_weight_value: false,
    //   logistics_fee_Calculation_mode: false,
    //   name_en:false,
    //   name_tc: false,
    //   net_weight: false,
    //   pic_staff_member_import: false,
    //   pic_staff_member_sales: false,
    //   pid: false,
    //   quantity_per_packaging_unit: false,
    //   remarks:false,
    //   specification: false,
    //   specification_code: false,
    //   status: false,
    //   type: false,
    //   variety: false,
    //   varietyCode: false // Default to active when creating new buyer
  });
  const [productCategory, setProductCategory] = useState([])

  const [brandData, setBrandData] = useState([])
  const [categoryData, setCategoryData] = useState([])
  const [originData, setOriginData] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [selectedOriginIds, setSelectedOriginIds] = useState([])
  const [selectedBrandName, setSelectedBrandName] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(null)
  const [brandOpen, setBrandOpen] = useState(false)
  const [originOpen, setOriginOpen] = useState(false)
  const [categoryOpen, setCategoryOpen] = useState(false)


  useEffect(() => {
    fetchCategoryData('', setCategoryData);
    fetchOriginData('', setOriginData);
    fetchBrand('', setBrandData)
  }, [])

  // const fetchBrand = async () => {
  //   const resp = await getApi(`/brand?per_page=50`);
  //   if (resp?.success === true) {
  //     setBrandData(resp?.data?.brands || []);
  //   }
  // }
  // const fetchCategoryData = async () => {
  //   const resp = await getApi(`/product-category?per_page=50`);
  //   if (resp?.success === true) {
  //     setCategoryData(resp?.data?.productCategories?.data || []);
  //   }
  // }
  // const fetchOriginData = async () => {
  //   const resp = await getApi(`/product-origin?per_page=50`);
  //   if (resp?.success === true) {
  //     setOriginData(resp?.data?.productOrigins?.data || []);
  //   }
  // }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setBrandOpen(false)
        setCategoryOpen(false)
        setOriginOpen(false)
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchProductCategoryData = async (search = '') => {
    try {

      const resp = await getApi(`/product-category?search=${encodeURIComponent(search)}&per_page=50`);
      if (resp?.success === true) {
        setProductCategory(resp?.data?.productCategories?.data || []);
      }
    } catch (error) {
      //   toast.error('Failed to fetch category details');
    } finally {
    }
  };

  const fetchProducts = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const queryParams = new URLSearchParams();
      if (Array.isArray(selectedCategoryIds)) {
        selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
      } else if (selectedCategoryIds) {
        queryParams.append('category_ids[]', selectedCategoryIds);
      }
      if (Array.isArray(selectedBrandName)) {
        selectedBrandName.forEach((id) => queryParams.append('brands[]', id));
      } else if (selectedBrandName) {
        queryParams.append('brands[]', selectedBrandName);
      }
      if (Array.isArray(selectedOriginIds)) {
        selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
      } else if (selectedOriginIds) {
        queryParams.append('origin_ids[]', selectedOriginIds);
      }
      queryParams.append('search', searchQuery);
      queryParams.append('page', currentPage);
      queryParams.append('per_page', itemsPerPage);
      const response = await getApi(`/product?${queryParams.toString()}`);
      //   const response = await getApi(`/product?search=${encodeURIComponent(searchQuery)}&page=${currentPage}&per_page=${itemsPerPage}&category_ids[]=${selectedCategoryIds}&origin_ids[]=${selectedOriginIds}&brands[]=${selectedBrandName}`);

      if (response?.success) {
        setProduct(response.data.products?.data || []);
        setPageCount(response?.data?.products?.last_page || 1)
      } else {
        setError(response?.msg || 'Failed to fetch product');
      }
    } catch (error) {
      setError(error.message || 'Failed to fetch product');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchProducts();
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery, currentPage, itemsPerPage, selectedCategoryIds, selectedBrandName, selectedOriginIds]);

  useEffect(() => {
    if (searchTerm !== '') {
      // filterData()
      if (categoryOpen) {
        const data = filteredCategories(searchTerm, categoryData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (originOpen) {
        const data = filteredCategories(searchTerm, originData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (brandOpen) {
        const data = filteredCategories(searchTerm, brandData);
        setFilterData(data?.length > 0 ? data : []);
      }
    }

  }, [searchTerm])

  useEffect(() => {
    fetchProductCategoryData()
  }, [])

  const handleChange = (name, value) => {
    // const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCategoryChange = (e) => {
    const selectedName = e;
    // const selectedName = e.target.value;
    const selectedCategory = categoryData.find(cat => cat.name === selectedName);

    if (selectedCategory) {
      setSelectedCategoryIds(prevIds => {
        // Toggle selection - add if not present, remove if present
        return prevIds.includes(selectedCategory.id)
          ? prevIds.filter(id => id !== selectedCategory.id)
          : [...prevIds, selectedCategory.id];
      });

    }
  };
  const handleOriginChange = (e) => {
    const selectedName = e;
    // const selectedName = e.target.value;
    const selectedOrigin = originData.find(cat => cat.name === selectedName);

    if (selectedOrigin) {
      setSelectedOriginIds(prevIds => {
        // Toggle selection - add if not present, remove if present
        return prevIds.includes(selectedOrigin.id)
          ? prevIds.filter(id => id !== selectedOrigin.id)
          : [...prevIds, selectedOrigin.id];
      });

    }
  };
  const handleBrandChange = (e) => {
    const selectedName = e;
    // const selectedName = e.target.value;
    const selectedOrigin = brandData.find(cat => cat === selectedName);

    if (selectedOrigin) {
      setSelectedBrandName(prevIds => {
        // Toggle selection - add if not present, remove if present
        return prevIds.includes(selectedOrigin)
          ? prevIds.filter(id => id !== selectedOrigin)
          : [...prevIds, selectedOrigin];
      });

    }
  };

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };

  const createGroup = () => {
    const idsStatus = product
      .filter(item => 'status' in item && item.status === true)
      .map(item => item);

    dispatch(setIdsStatus({ idsStatus, method: 'add' }));
    navigate('/admin/product-group')
  }

  return (
    <div className="RightSideDiv product-single product-page-ui">

      {showImportModal &&

        <Import setImportFile={setImportFile} importFile={importFile} searchQuery={searchQuery} fetchData={fetchProducts} setShowImportModal={setShowImportModal} routeEnd={'/product/import'} routeexport={'/product/export'} type='Product' />
      }

      {showDeleteModal && (
        <DeleteModal setShowDeleteModal={setShowDeleteModal} todelete={productToDelete} isLoading={isLoading} setIsLoading={setIsLoading} settoDelete={setProductToDelete} fetchData={fetchProducts} route={`/product/${productToDelete?.id}`} type={'product'} />
      )}

      {showGroupCodesModal && (
        <div className="modal-backdrop" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1050
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            borderRadius: '5px',
            width: '400px',
            maxWidth: '90%',
            maxHeight: '90%',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
          }}>
            <div className="modal-header" style={{

            }}>
              <h3 style={{
                margin: '0',
                fontSize: '1.2rem',
              }} >Product Groups</h3>
              <button className="close-btn" onClick={() => setShowGroupCodesModal(false)} style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.5rem'
              }}>
                <img src={window.getPublicUrl('/assets/images/close.svg')} alt="Close" width="15" height="15" />
              </button>
            </div>
            <div className="modal-body" style={{
                padding: '0',
              maxHeight: '300px',
              overflowY: 'auto'
            }}>
              <ul className="group-codes-list" style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                {selectedProductGroups.map((group, index) => (
                  <li key={index} style={{
                    padding: '8px 0',
                    borderBottom: index < selectedProductGroups.length - 1 ? '1px solid #eee' : 'none'
                  }}>{group.group_no}</li>
                ))}
                {selectedProductGroups.length === 0 && <li>No group codes available</li>}
              </ul>
            </div>
          </div>
        </div>
      )}

      {methodType === '' &&
        <div class="row">
          <div class="col-sm-12">
            <div className="setting-right setting-right-table table-border-show product-grouping arrival single-product">
              <div class="table-header">
                <div className='header-left'>
           

                    <div className="links position-relative">
                             <div className="search-card">
                    <img src={window.getPublicUrl('/assets/images/search-icon.svg')} alt="" />
                    <input
                      type="text"
                      class="search-input"
                      placeholder="Search Product"
                      value={searchQuery}
                      onChange={(e) => {setSearchQuery(e.target.value);setCurrentPage(1)}}
                    />

                  </div>
                 
                        <MultiSelectDropdown
                          categoryData={categoryData}
                          selectedCategories={selectedCategoryIds}
                          setSelectedCategories={setSelectedCategoryIds}
                          placeholder='Select Categories...'
                          noOptionsMessage='No categories available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchCategoryDataFilter}
                        />
                      {/* <div className='selctions-option'>
                        <input placeholder="category" className={`category affter-change-cs category-select ${categoryOpen ? 'before-change-cs' :''}`} value={categoryOpen?searchTerm:''} onChange={(e)=>setSearchTerm(e?.target?.value)} onClick={() => {setCategoryOpen(!categoryOpen);setSearchTerm('')}}/>
                        {categoryOpen &&
                        <div className='select-option' ref={dropdownRef}>
                          
                            {categoryData && (searchTerm==='' ? categoryData?.length >0 :filterDatas?.length>0) ? (searchTerm==='' ? categoryData : filterDatas)?.map((x,index)=>{
                              return(
                                <span key={index}>
                                <label className="checbox-cs">
                                <input type="checkbox" onClick={(e) => handleCategoryChange(x?.name)} checked={selectedCategoryIds.includes(x?.id) ? true : false}/>
                                <span className="checkmark"></span>
                              </label>
                              {x?.name}
                            </span>
                              )
                            })
                          :
                          <span className="no-data-available">No Categories Available</span>
                          }
                        </div>
}
                      </div> */}
                      {/* <AsyncPaginate
                        value={
                          formData.related_product
                            ? {
                              value: formData.id,
                              label: `${formData.name} | (${formData.code})`,
                            }
                            : null
                        }
                        loadOptions={relatedProductsLoadOptions('category', setSelectedCategoryIds)}
                        onChange={handleSelectionChange('category', setSelectedCategoryIds)}
                        placeholder="Search and select related category"
                        isClearable
                        // isLoading={loading}
                        additional={{
                          page: 1,
                        }}
                      /> */}
                      {/* <div className='selctions-option'>
                        <input placeholder="origin" className={`category affter-change-cs category-select ${originOpen ? 'before-change-cs' :''}`} value={originOpen?searchTerm:''} onChange={(e)=>setSearchTerm(e?.target?.value)} onClick={() => {setOriginOpen(!originOpen);setSearchTerm('')}}/>
                        {originOpen &&
                        <div className='select-option' ref={dropdownRef}>
                        {(searchTerm==='' ? originData?.length >0 :filterDatas?.length>0) ?(searchTerm===''?originData:filterDatas).map((x, index) => (
                              <span key={index}>
                                <label class="checbox-cs">
                                  <input type="checkbox" onClick={(e) => handleOriginChange(x?.name)} checked={selectedOriginIds.includes(x?.id) ? true : false}/>
                                  <span class="checkmark" ></span>
                                </label>
                                {x.name}
                              </span>
                            ))
                            :
                            <span className="no-data-available">No Origin Available</span>
                            }
                        </div>
}
                      </div> */}

                        <MultiSelectDropdown
                          categoryData={originData}
                          selectedCategories={selectedOriginIds}
                          setSelectedCategories={setSelectedOriginIds}
                          placeholder="Select origin..."
                          noOptionsMessage='No origin available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchOriginDataFilter}
                        />
                      {/* <AsyncPaginate
                        value={
                          formData.related_product
                            ? {
                              value: formData.id,
                              label: `${formData.name} | (${formData.code})`,
                            }
                            : null
                        }
                        loadOptions={relatedProductsLoadOptions('origin', setSelectedOriginIds)}
                        onChange={handleSelectionChange('origin', setSelectedOriginIds)}
                        placeholder="Search and select related origin"
                        isClearable
                        // isLoading={loading}
                        additional={{
                          page: 1,
                        }}
                      /> */}
                      {/* <div className='selctions-option'>
                        <input placeholder="brand" className={`category affter-change-cs category-select ${brandOpen ? 'before-change-cs' : ''}`} value={brandOpen ? searchTerm : ''} onChange={(e) => setSearchTerm(e?.target?.value)} onClick={() => { setBrandOpen(!brandOpen); setSearchTerm('') }} />
                        {brandOpen &&
                          <div className='select-option' ref={dropdownRef}>
                            {(searchTerm === '' ? brandData?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? brandData : filterDatas).map((x, index) => (
                              <span key={index}>
                                <label class="checbox-cs">
                                  <input type="checkbox" onClick={(e) => handleBrandChange(x)} checked={selectedBrandName.includes(x) ? true : false} />
                                  <span class="checkmark" ></span>
                                </label>
                                {x}
                              </span>
                            ))
                              :
                              <span className="no-data-available">No Brand Available</span>
                            }
                          </div>
                        }
                      </div> */}
                                          <MultiSelectDropdown 
                                            categoryData={brandData}
                                            selectedCategories={selectedBrandName}
                                            setSelectedCategories={setSelectedBrandName}
                                            placeholder="Select brand..."
                                            noOptionsMessage='No Brand available'
                                            setCurrentPage={setCurrentPage}
                                            fetchOptionsApi={fetchBrandFilter}
                                          />
                      {/* <AsyncPaginate
                        value={
                          formData.related_product
                            ? {
                              value: formData.id,
                              label: `${formData.name} | (${formData.code})`,
                            }
                            : null
                        }
                        loadOptions={relatedProductsLoadOptions('brand', setSelectedBrandName)}
                        onChange={handleSelectionChange('brand', setSelectedBrandName)}
                        placeholder="Search and select related brand"
                        isClearable
                        // isLoading={loading}
                        additional={{
                          page: 1,
                        }}
                      /> */}







                      {/* <select name="" id="" className="affter-change-cs"  onChange={handleCategoryChange} >
                          {categoryData?.length > 0 && categoryData.map((x, index) => (
          <option key={x.id} value={x.name} className={selectedCategoryIds.includes(x?.id)?'tick':''}>
            {x.name}
          </option>
        ))}
                          </select>
                        <select name="" id="" className="affter-change-cs" onChange={handleOriginChange}>
                        {originData?.length > 0 && originData.map((x, index) => (
          <option key={x.id} value={x.name}>
            {x.name}
          </option>
        ))}
        </select>

        <select name="" id="" className="affter-change-cs" onChange={handleBrandChange}>
                        {brandData?.length > 0 && brandData.map((x, index) => (
          <option key={index} value={x}>
            {x}
          </option>
        ))}
        </select> */}

                  </div>
                            <div class="table-actions">
                            {checkAddPermission(data?.permissions, 'product_list') && (
                  <button class="btn" onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}>
                    <img src={window.getPublicUrl('/assets/images/import.png')} alt="" />
                    Import
                  </button>
                )}
                  <button class="btn" onClick={() => handleExportFileProduct(product, searchQuery, 'product.xlsx', '/product/export', selectedBrandName)}>
                    <img src={window.getPublicUrl('/assets/images/export.svg')} alt="" />
                    Export
                  </button>
                  {checkAddPermission(data?.permissions, 'product_list') && (
                  <button class="btn" onClick={() => createGroup()}>
                    <img src={window.getPublicUrl('/assets/images/create-group.svg')} alt="" />
                    Create Group
                  </button>
                  )}
                  {/* 
                  {checkAddPermission(data?.permissions, 'product_list') && (
                    <button class="btn add" onClick={() => setMethodType('add')}>+ Add New Product</button>
                  )} */}
                </div>
                </div>
                {/* <div class="table-actions">
                  <button class="btn" onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}>
                    <img src={window.getPublicUrl('/assets/images/import.png')} alt="" />
                    Import
                  </button>
                  <button class="btn" onClick={() => handleExportFileProduct(product, searchQuery, 'product.xlsx', '/product/export', selectedBrandName)}>
                    <img src={window.getPublicUrl('/assets/images/export.svg')} alt="" />
                    Export
                  </button>
                  <button class="btn" onClick={() => createGroup()}>
                    <img src={window.getPublicUrl('/assets/images/create-group.svg')} alt="" />
                    Create Group
                  </button> */}
                  {/* 
                  {checkAddPermission(data?.permissions, 'product_list') && (
                    <button class="btn add" onClick={() => setMethodType('add')}>+ Add New Product</button>
                  )} */}
                {/* </div> */}
              </div>



              {/* <div class="table-header">
             <div className='header-left'>
            <div class="search-card">
              <img src="/snf/assets/images/search-icon.svg" alt="" />
              <input
                type="text"
                class="search-input"
                placeholder="Search Product Group..."
              />
            
            </div>
            </div>
            <div class="table-actions">
              <button class="btn">
                <img src={window.getPublicUrl('/assets/images/import.png')} alt="" />
                Import
              </button>
              <button class="btn">
                <img src={window.getPublicUrl('/assets/images/export.svg')} alt="" />
                Export
              </button>
              <button class="btn add" onClick={()=>setMethodType('add')}>+ Add New Product Group</button>
            </div>
          </div> */}
              <div className="permission-table-inner">
                <table class="custom-table table-striped">
                  <thead>
                    <tr>
                      <th class="checkbox"><label class="checbox-cs">
                        <input type="checkbox" onClick={(e) => handleUpdateAllCheckbox(e?.target?.checked, setProduct)} />
                        <span class="checkmark"></span>
                      </label></th>
                      <th class="code">Code</th>
                      <th class="name-en">Name(EN)</th>
                      <th class="name-tc">Name(TC)</th>
                      <th class="category">Category</th>
                      <th class="coo">Coo</th>
                      <th class="varierty">Varierty</th>
                      <th class="net-wt">Net Wt.</th>
                      <th class="specification">Specification</th>
                      <th class="pic-import">PIC Staff Member (Import)</th>
                      <th class="pic-sales">PIC Staff Member (Sales)</th>
                      <th class="groups">Group Code</th>
                      <th class="groups">Type</th>
                      <th class="action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="14" className="text-center">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="14" className="text-center text-danger">{error}</td>
                      </tr>
                    ) : product?.length === 0 ? (
                      <tr>
                        <td colSpan="14" className="text-center">No products found</td>
                      </tr>
                    ) : (
                      product?.length > 0 && product?.map((product, index) => (
                        <tr>
                          <td class="checkbox">
                            <label class="checbox-cs">
                              <input type="checkbox" onClick={(e) => handleUpdateDataCheckbox(product, e, setProduct)} checked={product?.status} />
                              <span class="checkmark"></span>
                            </label></td>
                          <td class="code">{product?.code}</td>
                          <td class="name-en">{product?.name_en}</td>
                          <td class="name-tc">{product?.name_tc}</td>
                          <td class="category">{product?.category}</td>
                          <td class="coo">{product?.coo}</td>
                          <td class="varierty">{product?.variety}</td>
                          <td class="net-wt">{product?.net_weight}</td>
                          <td class="specification">{product?.specification}</td>
                          <td class="pic-import">{product?.pic_staff_member_import}</td>
                          <td class="pic-sales">{product?.pic_staff_member_sales}</td>
                          <td class="groups">
                            {product?.groups && product.groups.length > 0 ? (
                              <>
                                {product.groups.slice(0, 3).map(group => group.group_no).join(', ')}
                                {product.groups.length > 3 && (
                                  <span
                                    className="see-more-link"
                                    onClick={() => {
                                      setSelectedProductGroups(product.groups);
                                      setShowGroupCodesModal(true);
                                    }}
                                    style={{
                                      color: '#0066cc',
                                      cursor: 'pointer',
                                      fontWeight: 'bold',
                                      textDecoration: 'underline'
                                    }}
                                  >
                                    {' '}See more
                                  </span>
                                )}
                              </>
                            ) : '-'}
                          </td>
                          <td class="pic-sales">{product?.type}</td>
                          <td class="action action-cs">

                            <div class="dropdown">
                       
                              <button class=" dropdown-toggle action-btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> <img src={window.getPublicUrl('/assets/images/dots-icon.svg')} alt="" /></button>
                              
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                {/* <li>
                                  {checkEditPermission(data?.permissions, 'supplier_list') && (
                                    <a href="#" className='dropdown-item'><span onClick={(e) => { e.preventDefault(); setupEditFormData(product, setFormData, setMethodType, setProductToEdit, formDataCopy); }}>Edit</span></a>
                                  )}
                                </li> */}
                                {/* <li>
                                  {checkDeletePermission(data?.permissions, 'product_list') && (
                                    <a href="#" className='dropdown-item' onClick={(e) => { e.preventDefault(); setProductToDelete(product); setShowDeleteModal(true); }}>Delete</a>
                                  )}
                                </li>  */}
                                <li>
                         
                                    <div className='dropdown-item'><span onClick={(e) => { e.preventDefault(); setupEditFormData(product, setFormData, setMethodType, setProductToEdit, formDataCopy); setMethodType('view'); }}>View</span></div>
                               
                                </li>

                              </ul>

                            </div>
                          </td>
                        </tr>
                      )))}
                  </tbody>
                </table>

              </div>
              <div class="table-footer d-flex justify-content-between table-pagination">
                <select name="" id="" className='affter-change-cs page' value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1) }}>
                <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                </select>
                <div className=''>
                  <TableFooter
                    pageCount={pageCount}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {/* {methodType === 'add' &&
                <div class="row">
                    <div class="col-sm-12">
                        <div class="setting-right position-relative setting-right-table">
                            <h3>Add New Product</h3>
                            <img src={window.getPublicUrl('/assets/images/close.svg')} class="close" alt="" />
                            <div class="setting-inner">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="productCode">Code<strong>*</strong></label>
                                            <input type="text" id="productCode" class="form-control" placeholder="Enter Code" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="pid">PID<strong>*</strong></label>
                                            <input type="text" id="pid" class="form-control" placeholder="Enter PID" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="status">Status<strong>*</strong></label>
                                            <select id="status" class="form-control">
                                                <option value="">Select Status</option>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="nameEn">Name (EN)<strong>*</strong></label>
                                            <input type="text" id="nameEn" class="form-control"
                                                placeholder="Enter Product Name" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="nameTc">Name (TC)<strong>*</strong></label>
                                            <input type="text" id="nameTc" class="form-control"
                                                placeholder="Enter Product Name" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="category">Category<strong>*</strong></label>
                                            <select id="category" class="form-control">
                                                <option value="">Select Category</option>
                                                <option value="fruits">Fruits</option>
                                                <option value="vegetables">Vegetables</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="categoryCode">Category Code<strong>*</strong></label>
                                            <select id="categoryCode" class="form-control">
                                                <option value="">Select Category</option>
                                                <option value="fruits">Fruits</option>
                                                <option value="vegetables">Vegetables</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="coo">COO<strong>*</strong></label>
                                            <input type="text" id="coo" class="form-control" placeholder="Enter COO" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="cooCode">COO Code<strong>*</strong></label>
                                            <input type="text" id="cooCode" class="form-control" placeholder="Enter COO Code" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="variety">Variety<strong>*</strong></label>
                                            <input type="text" id="variety" class="form-control" placeholder="Enter Variety" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="varietyCode">Variety Code</label>
                                            <input type="text" id="varietyCode" class="form-control"
                                                placeholder="Enter Variety Code" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="type">Type</label>
                                            <input type="text" id="type" class="form-control" placeholder="Enter Type" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="companyProductId">Company Product ID</label>
                                            <input type="text" id="companyProductId" class="form-control"
                                                placeholder="Enter Product ID" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="companyProductIdCode">Company Product ID Code</label>
                                            <input type="text" id="companyProductIdCode" class="form-control"
                                                placeholder="Enter Company Product ID Code" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="brand">Brand</label>
                                            <input type="text" id="brand" class="form-control" placeholder="Enter Brand" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="brandCode">Brand Code</label>
                                            <input type="text" id="brandCode" class="form-control"
                                                placeholder="Enter Brand Code" />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="netWeight">Net Weight</label>
                                            <input type="text" id="netWeight" class="form-control"
                                                placeholder="Enter Net Weight" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="specification">Specification</label>
                                            <input type="text" id="specification" class="form-control"
                                                placeholder="Enter Specification" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="specificationcode">Specification Code</label>
                                            <input type="text" id="specificationcode" class="form-control"
                                                placeholder="Enter Specification Code" />
                                        </div>
                                    </div>


                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="grossWeight">Gross Weight Value</label>
                                            <input type="text" id="grossWeight" class="form-control"
                                                placeholder="Enter Gross Weight Value" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="grossWeightUnit">Gross Weight Unit</label>
                                            <input type="text" id="grossWeightUnit" class="form-control"
                                                placeholder="Enter Unit" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="quantityPerUnit">Quantity Per Packaging Unit</label>
                                            <input type="text" id="quantityPerUnit" class="form-control"
                                                placeholder="Enter Quantity" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="logisticsMode">Logistics Fee Calculation Mode</label>
                                            <input type="text" id="logisticsMode" class="form-control"
                                                placeholder="Enter Logistics Mode" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="remarks">Remarks</label>
                                            <input type="text" id="remarks" class="form-control" placeholder="Enter Remarks" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="picstaffmember">PIC Staff Member (Import)</label>
                                            <input type="text" id="picstaffmember" class="form-control"
                                                placeholder="Enter PIC   Staff Member (Import)" />
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label for="picstaffmembersales">PIC Staff Member (Sales)</label>
                                            <input type="text" id="picstaffmembersales" class="form-control"
                                                placeholder="Enter PIC   Staff Member (Import)" />
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="button-settings">
                                <div class="col-sm-12">
                                    <div class="d-flex justify-content-end gap-3">
                                        <button class="reset">Reset</button>
                                        <button class="save" onClick={() => setMethodType('')}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            } */}
      {methodType === 'edit' &&
        <EditProduct formData={formData} productCategory={productCategory} setMethodType={setMethodType} type={'edit'} setFormData={setFormData} formDataCopy={formDataCopy} productToEdit={productToEdit} setError={setError} originData={originData} touched={touched} setTouched={setTouched} fetchProducts={fetchProducts} setIsLoading={setIsLoading} errors={error} isLoading={isLoading} setSearchTerm={setSearchTerm} searchTerm={searchTerm} filterDatas={filterDatas} setFilterData={setFilterData} />
      }
      {methodType === 'add' &&
        <EditProduct formData={formData} productCategory={productCategory} setMethodType={setMethodType} type={'add'} setFormData={setFormData} formDataCopy={formDataCopy} productToEdit={productToEdit} setError={setError} originData={originData} touched={touched} setTouched={setTouched} fetchProducts={fetchProducts} setIsLoading={setIsLoading} errors={error} isLoading={isLoading} setSearchTerm={setSearchTerm} searchTerm={searchTerm} filterDatas={filterDatas} setFilterData={setFilterData} />
      }
      {methodType === 'view' &&
        <EditProduct formData={formData} productCategory={productCategory} setMethodType={setMethodType} type={'view'} setFormData={setFormData} formDataCopy={formDataCopy} productToEdit={productToEdit} setError={setError} originData={originData} touched={touched} setTouched={setTouched} fetchProducts={fetchProducts} setIsLoading={setIsLoading} errors={error} isLoading={isLoading} setSearchTerm={setSearchTerm} searchTerm={searchTerm} filterDatas={filterDatas} setFilterData={setFilterData} />
      }
    </div>
  )
}

export default Product